import { __rest } from 'tslib';
import React from 'react';
import CategoryTitle from '../../Basic/CategoryTitle/CategoryTitle.mjs';
import Container from '../../Basic/Container/Container.mjs';
import HoverableImageLink from '../../Basic/Link/HoverableImageLink/HoverableImageLink.mjs';
import FlexContainer from '../../Containers/FlexContainer/FlexContainer.mjs';

const WhereToWatch = ({ options }) => {
    return (React.createElement(Container, null,
        React.createElement(FlexContainer, { direction: "column", gap: "1.5rem" },
            React.createElement(CategoryTitle, { uppercased: true, withMarker: true, href: "#" }, "Where to watch"),
            React.createElement(FlexContainer, { justifyContent: ['center', 'start'], gap: "1.5rem", flexWrap: "wrap" }, options.map((_a) => {
                var { id } = _a, rest = __rest(_a, ["id"]);
                return (React.createElement(HoverableImageLink, Object.assign({ key: id }, rest)));
            })))));
};

export { WhereToWatch as default };
//# sourceMappingURL=WhereToWatch.mjs.map
